export const searchOptions = [
  { value: "all", label: "All" },
  { value: "common_names", label: "Common names" },
  { value: "scientific_names", label: "Scientific name" },
];

export const arrangeByOptions = [
  { value: "genus", label: "By Genus" },
  { value: "family", label: "By Family" },
  { value: "created_at", label: "In Order Entered" },
];
export const animalDatabases = [
      { value: 'amphibians', label: 'Amphibians' },
      { value: 'arthropods', label: 'Arthropods' },
      { value: 'birds', label: 'Birds' },
      { value: 'fish & lamprey', label: 'Fish & Lamprey' },
      { value: 'mammals', label: 'Mammals' },
      { value: 'mollusks', label: 'Mollusks' },
      { value: 'reptiles', label: 'Reptiles' },
      { value: 'all', label: 'All' },
    ];
export const hideColumns = [
  // Basic fields
  "plant_type",
  "full_name",
  "unique_id",
  "monocot_dicot",
  "family_name",

  // Extra common names (hide 2-5, keep common_name_1)
  "common_name_2",
  "common_name_3",
  "common_name_4",
  "common_name_5",

  // Synonyms (hide all)
  "synonyms_1",
  "synonyms_2",
  "synonyms_3",
  "synonyms_4",

  // Custom/Chez fields (hide all)
  "chez_elevation",
  "chez_bloom_window",
  "chez_range",
  "chez_plant_type",

  // AI fields (hide all)
  "ai_description",
  "ai_differentiators",
  "col1_species_differentiator",
  "col1_key_characters",
  "col2_genus_confidence_check",
  "col2_quick_tells",
  "family_differentiator",
  "family_key_characters",

  // Jepson eFlora (hide most, keep main description visible)
  "distribution_outside_of_california",
  "habitat",
  "elevation_range",
  "flowering_time",
  "link_to_eflora_jepson",
  "cal_photo_link",
  "jepson_eflora_other_notes",
  "url",
  "bioregional_distributions",
  "taxonomy_notes",

  // Rankings (keep CRPR, state/federal visible, hide others)
  "global_rank",
  "forest_service_status",
  "CNPSRareLink",

  // CNPS Data (hide all detail fields)
  "cnps_notes",
  "cnps_taxonomy",
  "cnps_threats",
  "cnps_name",
  "cnps_quads",
  "cnps_california_counties_and_islands",

  // CAL IPC Data (hide all)
  "ipc_listed_weed",
  "calipc_rating",
  "calipc_description",
  "calipc_name",
  "calipc_genus",
  "calipc_species",
  "calipc_variety",
  "cdfa_rating",

  // CDFW Data (hide all)
  "cdfw_genus",
  "cdfw_species",
  "cdfw_variety",
  "cdfw_element_code",

  // BLM Data (hide all)
  "blm_recognized_name",
  "known_to_occur",
  "suspected_to_occur",
  "nnps",
  "nvstate_rank",
  "blm_family",
  "blm_sensitive",
  "blm_rank",

  // Wetland Status (hide all)
  "usace_wetland_status",
  "usace_wetland_name",
  "usda_common_name",
  "usda_symbol",
  "usda_arid_west_status",
  "usda_wmvc_status",

  // Legacy/unused fields
  "forest_service_rank",
  "local_county_rank",
  "counties",
  "animal_class",
  "animal_order",
  "common_type",
  "common_sub_type",
  "habit",
  "range",
  "host_plant",
  "federal_rank",
  "forest_service",
  "other",
  "iucn_rank", // Hidden by default - very low data (0.7%)
];
export const extraDefaultColumns = [
  {
  title: "Note",
  // sorter: true,
  show: true,
  dataIndex: 'note'
}
];